import React from 'react';

const BeginSection = props => {
    const { children, shrink, size } = props;

    let sizeClass = !shrink ? 'col-8' : 'col-5';
    if (size) {
        sizeClass = `col-${size}`;
    }
    return (
        <div className={sizeClass}>
            {children}
        </div>
    );
};

export default BeginSection;
